export const getText = (text, lang, t) => {
  if (!text) return '';

  /* 번역 key 문자열인 경우 */

  if (typeof text === 'string') {
    return t ? t(text) : text;
  }

  /* 다국어 객체인 경우 */

  if (typeof text === 'object') {
    return text[lang] ?? text.en ?? '';
  }

  return '';
};

export function getSafeTransform(transforms, product) {
  const defaultTransform = {
    position: {
      x: 0,
      y: 0.6,
    },

    depth: 0.02,

    scale: 0.8,
  };

  const raw = transforms?.[product];

  return {
    ...defaultTransform,
    ...raw,

    position: {
      ...defaultTransform.position,
      ...(raw?.position ?? {}),
    },
  };
}
